import * as angular from 'angular';

(function () {
    'use strict';

    /**
     * Override Angular's $exceptionHandler to instead handle exceptions with our own exceptionLoggingService.
     *
     * @see http://engineering.talis.com/articles/client-side-error-logging/
     */
    angular.module('app').provider('$exceptionHandler', {
        $get: function (exceptionLoggingService) {
            return exceptionLoggingService;
        }
    });
})();
